<template>
  <div
    class="login-container"
    :class="{ 'sign-up-mode': mode.register }"
  >
    <div class="forms-container">
      <div class="signin-signup">
        <div class="form-div sign-in-form">
          <h2 class="login-title">
            회의실 예약 시스템
          </h2>
          <h3>
            Sign in
          </h3>
          <div class="input-field">
            <v-icon>mdi-account</v-icon>
                <input
                  ref="email"
                  v-model="model.email"
                  type="text"
                  placeholder="Email"
                >
<!--                <input-->
<!--                  ref="email"-->
<!--                  v-model="model.email"-->
<!--                  type="text"-->
<!--                  placeholder="ID"-->
<!--                >-->
          </div>
          <div class="input-field">
            <v-icon>mdi-lock-outline</v-icon>
            <input
              v-model="model.password"
              type="password"
              placeholder="Password"
              @keydown.enter="login"
            >
          </div>
          <div>
            <span class="login-alert">{{ error }}</span>
          </div>
          <input
            v-if="!loading"
            type="button"
            value="Login"
            class="btn solid"
            @click="login"
          >
          <div
            v-else
            id="loading"
          />
        </div>
        <div class="form-div sign-up-form">
          <h2 class="login-title">
            회의실 예약 시스템
          </h2>
          <h3>
            Sign up
          </h3>
          <div class="input-field">
            <v-icon>mdi-account</v-icon>
            <input
              ref="username"
              v-model="model.username"
              type="text"
              placeholder="Username"
            >
          </div>
          <div class="input-field">
            <v-icon>mdi-email-open-outline</v-icon>
            <input
              v-model="model.email"
              type="email"
              placeholder="Email"
            >
          </div>
          <div class="input-field">
            <v-icon>mdi-lock-outline</v-icon>
            <input
              v-model="model.password"
              type="password"
              placeholder="Password"
              @keydown.enter="register"
            >
          </div>
          <div>
            <span class="login-alert">{{ regError }}</span>
          </div>
          <input
            v-if="!loading"
            type="button"
            class="btn"
            value="Sign up"
            @click="register"
          >
          <div
            v-else
            id="loading"
          />
        </div>
      </div>
    </div>

<!--    <div class="panels-container">-->
<!--      <div class="panel left-panel">-->
<!--        <div class="content">-->
<!--          <h3>NEOVISION</h3>-->
<!--          <p>-->
<!--            회의실 예약 시스템에 처음 오셨나요? 아래의 SIGN UP 을 클릭해주세요.-->
<!--          </p>-->
<!--          <button-->
<!--            id="sign-up-btn"-->
<!--            class="btn transparent"-->
<!--            @click="signUp"-->
<!--          >-->
<!--            Sign up-->
<!--          </button>-->
<!--        </div>-->
<!--        <img-->
<!--          :src="require('@/assets/login/log.svg')"-->
<!--          class="image"-->
<!--          alt=""-->
<!--        >-->
<!--      </div>-->
<!--      <div class="panel right-panel">-->
<!--        <div class="content">-->
<!--          <h3>NEOVISION</h3>-->
<!--          <p>-->
<!--            이미 회원가입을 하셨나요? 아래의 SIGN IN 을 클릭해주세요.-->
<!--          </p>-->
<!--          <button-->
<!--            id="sign-in-btn"-->
<!--            class="btn transparent"-->
<!--            @click="signIn"-->
<!--          >-->
<!--            Sign in-->
<!--          </button>-->
<!--        </div>-->
<!--        <img-->
<!--          :src="require('@/assets/login/register.svg')"-->
<!--          class="image"-->
<!--          alt=""-->
<!--        >-->
<!--      </div>-->
<!--    </div>-->
  </div>
</template>

<script>
  // Vuex
  import { get, sync } from 'vuex-pathify'
  import crypto from 'crypto-js'

  export default {
    data: () => ({
      // hostName: process.env.HOST_NAME,
      mode: {
        register: false,
      },
      error: null,
      regError: null,
      loading: false,
      model: {
        username: '',
        email: '',
        password: '',
        passwordAgain: '',
      },
      defaultModel: {
        username: '',
        email: '',
        password: '',
        passwordAgain: '',
      },
      // isIDSave: false,
    }),
    computed: {
      ...sync('user', [
        'info',
        'token',
      ]),
      ...get('user', [
        'info',
        'token',
      ]),
      ...get('app', [
        'items',
      ]),
    },
    async created () {
      // console.log(this.hostName)
      // this.menuSorting()
      // if (!Util.hasSession(this)) return

      // let menuPath = menu[1].path === undefined ? '/' + menu[1].items[0].component : menu[1].path
      // this.$router.replace(menuPath)
    },
    async mounted () {
      this.$refs.email.focus()
      // let check = this.$cookies.get('check')
      // if (check) {
      //   this.isIDSave = check
      //   this.model.email = this.$cookies.get('id')
      // }
      // 로그인성공시

      const user = this.$cookies.get('user')
      try {
        if (user) {
          this.$store.set('user/info', user)
          this.$store.set('user/token', user.token)
          this.$router.replace(this.items[0].to)
        }
      } catch (err) {
        this.error = err
      }
    },
    methods: {
      validateEmail (value) {
        if (!value) {
          return 'This field is required'
        }
        if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)) {
          return 'This field must be a valid email'
        }
        return true
      },
      async login () {
        if (this.model.email.trim() === '') {
          this.error = '이메일을 입력해주세요'
          // this.error = '아이디를 입력해주세요'
          return
        }
        if (this.model.password.trim() === '') {
          this.error = '비밀번호를 입력해주세요'
          return
        }
        this.loading = true
        const email = crypto.AES.encrypt(this.model.email, process.env.VUE_APP_PASSWORD_SECRET || 'passwordQ1W2E3R!').toString()
        const password = crypto.AES.encrypt(this.model.password, process.env.VUE_APP_PASSWORD_SECRET || 'passwordQ1W2E3R!').toString()
        this.$http.post('/api/auth/login', { email: email, password: password }).then((response) => {
          console.log(response)
          this.loginSuccess(response)
        }).catch(error => {
          this.error = error.response.data.error
          this.loading = false
        })
      },
      register () {
        if (this.model.username.trim() === '') {
          this.regError = '이름을 입력해주세요'
          return
        }
        if (this.model.email.trim() === '') {
          this.regError = '이메일을 입력해주세요'
          return
        }
        if (this.model.password.trim() === '') {
          this.regError = '비밀번호를 입력해주세요'
          return
        }
        this.loading = true
        const email = crypto.AES.encrypt(this.model.email, process.env.VUE_APP_PASSWORD_SECRET || 'passwordQ1W2E3R!').toString()
        const password = crypto.AES.encrypt(this.model.password, process.env.VUE_APP_PASSWORD_SECRET || 'passwordQ1W2E3R!').toString()
        this.$http.post('/api/auth/register', { email: email, password: password, username: this.model.username }).then((response) => {
          this.loginSuccess(response)
          this.model = Object.assign({}, this.defaultModel)
          this.regError = null
        }).catch(error => {
          this.regError = error.response.data.error
          this.loading = false
        })
      },
      signUp () {
        this.model.email = ''
        this.model.password = ''
        this.model.username = ''
        this.error = null
        this.mode.register = true
        this.$refs.username.focus()
      },
      signIn () {
        this.model.email = ''
        this.model.password = ''
        this.error = null
        this.mode.register = false
        this.$refs.email.focus()
      },
      async loginSuccess (response) {
        this.$store.set('user/info', response.data.user)
        this.$store.set('user/token', response.data.token)

        this.$cookies.set('user', { ...response.data.user, token: response.data.token }, 0)
        this.$http.defaults.headers.common.Authorization = 'Bearer ' + response.data.token

        // const lastAccessInfoUpdate = (await this.$http.post('/api/v1/users/lastAccessInfo'))
        // console.log(lastAccessInfoUpdate)

        // if (Boolean(this.isIDSave) === true) {
        //   this.$cookies.set('id', this.model.email, -1)
        //   this.$cookies.set('check', this.isIDSave, -1)
        // } else {
        //   this.$cookies.remove('id')
        //   this.$cookies.remove('check')
        // }
        setTimeout(() => {
          if (this.token) {
            this.$router.replace(this.items[0].to)
          }
          // let menuPath = menu[1].path === undefined ? '/' + menu[1].items[0].component : menu[1].path
          // this.$router.replace(menuPath)
          this.loading = false
        }, 500)
      },
    },
  }
</script>
<style scoped>

.login-container {
  position: relative;
  width: 100%;
  background-color: #fff;
  min-height: 100vh;
  overflow: hidden;
}

.forms-container {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}

.signin-signup {
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  left: 75%;
  width: 50%;
  transition: .8s .5s ease-in-out;
  display: grid;
  grid-template-columns: 1fr;
  z-index: 5;
}

.form-div {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 0rem 5rem;
  transition: all 0.2s 0.5s;
  overflow: hidden;
  grid-column: 1 / 2;
  grid-row: 1 / 2;
}

.form-div.sign-up-form {
  opacity: 0;
  z-index: 1;
}

.form-div.sign-in-form {
  z-index: 2;
}

.login-title {
  font-size: 2.2rem;
  color: #444;
  margin-bottom: 10px;
}

.input-field {
  max-width: 380px;
  width: 100%;
  background-color: #f0f0f0;
  margin: 10px 0;
  height: 55px;
  border-radius: 55px;
  display: grid;
  grid-template-columns: 15% 85%;
  padding: 0 0.4rem;
  position: relative;
}

.input-field i {
  text-align: center;
  line-height: 55px;
  color: #acacac;
  transition: 0.3s;
  font-size: 1.1rem;
}

.input-field input {
  background: none;
  outline: none;
  border: none;
  line-height: 1;
  font-weight: 600;
  font-size: 1.1rem;
  color: #333;
}

.input-field input::placeholder {
  color: #aaa;
  font-weight: 500;
}

.social-text {
  padding: 0.7rem 0;
  font-size: 1rem;
}

.social-media {
  display: flex;
  justify-content: center;
}

.social-icon {
  height: 46px;
  width: 46px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 0.45rem;
  color: #333;
  border-radius: 50%;
  border: 1px solid #333;
  text-decoration: none;
  font-size: 1.1rem;
  transition: 0.1s;
}

.social-icon:hover {
  color: #4481eb;
  border-color: #4481eb;
}

.btn {
  width: 150px;
  background-color: #5995fd;
  border: none;
  outline: none;
  height: 49px;
  border-radius: 49px;
  color: #fff;
  text-transform: uppercase;
  font-weight: 600;
  margin: 10px 0;
  cursor: pointer;
  transition: 0.3s;
}

.btn:hover {
  background-color: #4d84e2;
}
.panels-container {
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
}

.login-container:before {
  content: "";
  position: absolute;
  height: 2000px;
  width: 2000px;
  top: -10%;
  right: 48%;
  transform: translateY(-50%);
  background-image: linear-gradient(-45deg, #4481eb 0%, #04befe 100%);
  transition: 1.5s ease-in-out;
  border-radius: 50%;
  z-index: 6;
}

.image {
  width: 100%;
  transition: transform .9s ease-in-out;
  transition-delay: 0.2s;
}

.panel {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: space-around;
  text-align: center;
  z-index: 6;
}

.left-panel {
  pointer-events: all;
  padding: 3rem 17% 2rem 12%;
}

.right-panel {
  pointer-events: none;
  padding: 3rem 12% 2rem 17%;
}

.panel .content {
  color: #fff;
  transition: transform 0.7s ease-in-out;
  transition-delay: 0.4s;
}

.panel h3 {
  font-weight: 600;
  line-height: 1;
  font-size: 1.5rem;
}

.panel p {
  font-size: 0.95rem;
  padding: 0.7rem 0;
}

.btn.transparent {
  margin: 0;
  background: none;
  border: 2px solid #fff !important;
  width: 130px;
  height: 41px;
  font-weight: 600;
  font-size: 0.8rem;
}

.right-panel .image,
.right-panel .content {
  transform: translateX(800px);
}

/* ANIMATION */

.login-container.sign-up-mode:before {
  transform: translate(100%, -50%);
  right: 52%;
}

.login-container.sign-up-mode .left-panel .image,
.login-container.sign-up-mode .left-panel .content {
  transform: translateX(-800px);
}

.login-container.sign-up-mode .signin-signup {
  left: 25%;
}

.login-container.sign-up-mode .form-div.sign-up-form {
  opacity: 1;
  z-index: 2;
}

.login-container.sign-up-mode .form-div.sign-in-form {
  opacity: 0;
  z-index: 1;
}

.login-container.sign-up-mode .right-panel .image,
.login-container.sign-up-mode .right-panel .content {
  transform: translateX(0%);
}

.login-container.sign-up-mode .left-panel {
  pointer-events: none;
}

.login-container.sign-up-mode .right-panel {
  pointer-events: all;
}

@media (max-width: 870px) {
  .login-container {
    min-height: 800px;
    height: 100vh;
  }
  .signin-signup {
    width: 100%;
    top: 80%;
    transform: translate(-50%, -100%);
    transition: .8s .6s ease-in-out;
  }

  .signin-signup,
  .login-container.sign-up-mode .signin-signup {
    left: 50%;
  }

  .panels-container {
    grid-template-columns: 1fr;
    grid-template-rows: 1fr 2fr 1fr;
  }

  .panel {
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    padding: 2.5rem 8%;
    grid-column: 1 / 2;
  }

  .right-panel {
    grid-row: 3 / 4;
  }

  .left-panel {
    grid-row: 1 / 2;
  }

  .image {
    width: 200px;
    transition: transform 0.7s ease-in-out;
    transition-delay: 0.4s;
  }

  .panel .content {
    padding-right: 15%;
    transition: transform 0.7s ease-in-out;
    transition-delay: 0.6s;
  }

  .panel h3 {
    font-size: 1.2rem;
  }

  .panel p {
    font-size: 0.7rem;
    padding: 0.5rem 0;
  }

  .btn.transparent {
    width: 110px;
    height: 35px;
    font-size: 0.7rem;
  }

  .login-container:before {
    width: 1500px;
    height: 1500px;
    transform: translateX(-50%);
    left: 30%;
    bottom: 68%;
    right: initial;
    top: initial;
    transition: 1.5s ease-in-out;
  }

  .login-container.sign-up-mode:before {
    transform: translate(-50%, 100%);
    bottom: 32%;
    right: initial;
  }

  .login-container.sign-up-mode .left-panel .image,
  .login-container.sign-up-mode .left-panel .content {
    transform: translateY(-300px);
  }

  .login-container.sign-up-mode .right-panel .image,
  .login-container.sign-up-mode .right-panel .content {
    transform: translateY(0px);
  }

  .right-panel .image,
  .right-panel .content {
    transform: translateY(300px);
  }

  .login-container.sign-up-mode .signin-signup {
    top: 10%;
    transform: translate(-50%, 0);
  }
}

@media (max-width: 570px) {
  form {
    padding: 0 1.5rem;
  }

  .image {
    display: none;
  }
  .panel .content {
    padding: 0.5rem 1rem;
  }
  .login-container {
    padding: 1.5rem;
  }

  .login-container:before {
    bottom: 72%;
    left: 50%;
  }

  .login-container.sign-up-mode:before {
    bottom: 28%;
    left: 50%;
  }
}

.login-alert {
  color: red;
}

#loading {
  display: inline-block;
  width: 50px;
  height: 50px;
  border: 3px solid darkgray;
  border-radius: 50%;
  border-top-color: black !important;
  animation: spin 1s ease-in-out infinite;
  -webkit-animation: spin 1s ease-in-out infinite;
}

@keyframes spin {
  to { -webkit-transform: rotate(360deg); }
}
@-webkit-keyframes spin {
  to { -webkit-transform: rotate(360deg); }
}
</style>
